import { createHttpClient } from '../../../api/http';
import { serviceUrls } from '../../../config/serviceUrls';
import type { LearnerCurriculumMeResponse } from '../learnerCurriculumTypes';

const client = createHttpClient(serviceUrls.gateway, { timeoutMs: 20_000 });

export async function fetchMyLearnerCurriculum(): Promise<LearnerCurriculumMeResponse> {
  const res = await client.get<LearnerCurriculumMeResponse>('/v1/curriculum/enrollments/me');
  return res.data;
}
